const STAGING = 'staging';
const PRODUCTION = 'production';
const DEVELOPMENT = 'development';

let hostname;
let protocol;

if (window.location && window.location.hostname && window.location.protocol) {
  hostname = window.location.hostname.replace(/^(signup)\./g, '');
  ({ protocol } = window.location);
} else {
  hostname = '';
  protocol = '';
}

const apiRoot = `${protocol}//api.${hostname}`;
const websiteRoot = `${protocol}//${hostname}`;

const config = {
  [PRODUCTION]: {
    API_ROOT: apiRoot,
    APP_URL: 'https://app.bench.co',
    ASSETS_PATH: '/assets/images/',
    CONVERT_ENDPOINT: 'https://marketing.appv2.bench.co/signup/convert',
    SEGMENT_WRITE_KEY: '7opS5SOrz8WirpNspL2c4kop7zNN1qeO',
    WEBSITE_URL: 'https://bench.co',
    DATADOG_APPLICATION_ID: 'a3dff9ee-0160-478f-9397-ed1164228a16',
    DATADOG_CLIENT_TOKEN: 'pubcbbf515829d88687607fd3167a06a25d'
  },
  [STAGING]: {
    API_ROOT: apiRoot,
    APP_URL: 'https://app.10sheet.ca',
    ASSETS_PATH: '/assets/images/',
    CONVERT_ENDPOINT: 'https://marketing.appv2.bench.co/signup/convert',
    SEGMENT_WRITE_KEY: 'ckibuthkr6',
    WEBSITE_URL: 'https://10sheet.ca',
    DATADOG_APPLICATION_ID: '',
    DATADOG_CLIENT_TOKEN: ''
  },
  [DEVELOPMENT]: {
    API_ROOT: apiRoot,
    APP_URL: `${protocol}//app.${hostname}`,
    ASSETS_PATH: '/assets/images/',
    CONVERT_ENDPOINT: 'https://marketing.dev.bench.co/signup/convert',
    SEGMENT_WRITE_KEY: 'ckibuthkr6',
    WEBSITE_URL: websiteRoot,
    DATADOG_APPLICATION_ID: '67eb3455-aa8c-4841-93e4-52b147e078b6',
    DATADOG_CLIENT_TOKEN: 'pub471e3e18ee0de7108c0ec1611ca9e0b8',
    BENCH_USER: process.env.BENCH_USER,
  },
};

const isLocalDevelopmentHost = (hostname = window.location.hostname) =>
  /(localhost|benchception\.co|nginx\.service\.bench|.*\.legacy\.dev\.bench\.co|.*dev\.10sheet\.ca)$/i.test(
    hostname,
  );

export const getEnvironmentName = () => {
  if (isLocalDevelopmentHost()) {
    return DEVELOPMENT;
  }

  if (/10sheet\.ca|bench-signup-preview\.netlify\.com/.test(window.location.hostname)) {
    return STAGING;
  }

  if (/bench\.co/.test(window.location.hostname)) {
    return PRODUCTION;
  }

  return DEVELOPMENT;
};
export default config[getEnvironmentName()];
